import * as jsPdf from "./modules/print/jspdf.min";
global.jsPDF = jsPdf;

import VersionInfo from './version.js';
import Scene from "./scene";
import AbstractElement from "./elements/abstract_element";
import Element from "./elements/element";
import Point from "./elements/point";
import GeoPoint from "./elements/geo_point";
import Line from "./elements/line";
import GeoPath from "./elements/geo_path";
import Skybox from "./elements/sky_box";
import SkyDome from "./elements/sky_dome";
import GroundPlane from "./elements/ground_plane";
import HeightMapTile from "./elements/height_map_tile";
import ChunkLODNode from "./elements/chunk_lod_node";
import BoundingBox from "./elements/bounding_box";
import Plane from "./elements/plane";
import Tube from "./elements/tube";
import TexturedQuad from "./elements/hud_elements/textured_quad";
import SightPoint from "./elements/hud_elements/sight_point";
import GeometryEntity from "./elements/geometry_entities/geometry_entity";
import PointEntity from "./elements/geometry_entities/point_entity";
import GeoEntity from "./elements/geometry_entities/geo_entity";
import TownEntity from "./elements/geometry_entities/town_entity";
import MountainEntity from "./elements/geometry_entities/mountain_entity";
import WaterEntity from "./elements/geometry_entities/water_entity";
import GeoPathsManager from "./geo_paths_manager";
import SceneRenderSettings from "./modules/render_settings/scene_render_settings";
import SceneBackground from "./modules/background/scene_background";
import SceneApplication from "./modules/application/scene_application";
import SceneActivity from "./modules/activity/scene_activity";
import SceneGroundPlane from "./modules/ground_plane/scene_ground_plane";
import SceneEffects from "./modules/effects/scene_effects";
import SceneView from "./modules/view/scene_view";
import hwcamera from "./modules/hw_camera/scene_hw_camera";
import hwcamerasimple from "./modules/hw_camera/scene_hw_camera_simple";
import HUDModule from "./modules/hud/scene_hud";
import ViewControlsModule from "./modules/view_controls/scene_view_controls";
import ViewModeModule from "./modules/view_mode/scene_view_mode";
import SaveModule from "./modules/save/scene_save";
import GeoLocationModule from "./modules/geo_location/scene_geo_location";
import TotalStationModule from "./modules/total_station/scene_total_station";

//@ts-ignore
import {ViewModeEnum} from "./modules/view_mode/scene_view_mode_enums.ts";
import {MouseActionEnum, EViewControls, EViewControlsFamily} from "./modules/view_controls/scene_view_controls_enums.ts";
import LightingSettings from "./modules/lighting/scene_lighting";
import ShadowLightingSettings from "./modules/lighting/shadow_lighting_settings";
import VRLightingSettings from "./modules/lighting/vr_lighting_settings";
import SceneLighting from "./modules/lighting/scene_lighting";
import Fog from "./modules/lighting/fog";
import SSAO from "./modules/lighting/ssao";
import SceneLogo from "./modules/logo/scene_logo";
import SceneShadows from "./modules/shadows/scene_shadows";
import SceneClippingPlane from "./modules/clipping_plane/scene_clipping_plane";
import Listener from "./listener";
import PrimitivePoint from "./primitive_point";
import Picker from "./modules/picking/picker";
import PrimitivePointPicker from "./modules/picking/primitive_point_picker";
import ElementPicker from "./modules/picking/element_picker";
import PoiPicker from "./modules/picking/poi_picker";
import GeoElementsPicker from "./modules/picking/geo_elements_picker";
import ScenePicking from "./modules/picking/scene_picking";
import SceneAnnotations from "./modules/annotations/scene_annotations";
import Annotation from "./modules/annotations/annotation";
//import HWCameraSimpleAPI from "./modules/hw_camera/HWCameraSimpleAPI";
//import HWCameraAPI from "./modules/hw_camera/HWCameraAPI";
import SceneManipulator from "./modules/manipulators/scene_manipulator";
import SceneAnimator from "./modules/animations/scene_animator";
import ScenePrint from "./modules/print/scene_print";
import JsBoundingBox from "./bounding_box";
import CameraAnimation from "./camera_animation";
import SceneDocument from "./structural_elements/document";
import Model from "./structural_elements/model";
import Aggregation from "./structural_elements/aggregation";
import ModelsAggregation from "./structural_elements/models_aggregation";
import ElementsAggregation from "./structural_elements/elements_aggregation";
import MercatorProjection from "./terrain/mercator_projection";
import WGS84Projection from "./terrain/wgs84_projection";
import TerrainTileAddress from "./terrain/terrain_tile_address";
import TesselatedArea from "./terrain/tesselated_area";
import TerrainTile from "./terrain/terrain_tile";
import Globe from "./globe/globe";

import {ELogoType} from "./modules/logo/scene_logo_enums.ts";
import {EBackgroundType} from "./modules/background/scene_background_enums.ts";
import {BuildingElementTypeEnum, FaceClassificationEnum} from "./structural_elements/model_enums.ts";
import {EOutlinesStyle} from "./modules/render_settings/scene_render_settings_enums.ts";
import Curve from "./elements/curve";
import PoiEntity from "./elements/geometry_entities/poi_entity";
import AnimationEntity from "./elements/geometry_entities/animation_entity";
import MeasurePointEntity from "./elements/geometry_entities/measure_point_entity";
import Terrain from "./terrain/terrain";
import {ELightingDateTimeType, EShadowType, ESunDirectionType} from "./modules/lighting/scene_lighting_enums.ts";

import {CompassTypeEnum} from "./modules/hud/scene_hud_enums.ts";
import RenderSettingsModule from "./modules/render_settings/scene_render_settings";
// import IGeoLocationInfo from "./modules/geo_location/scene_geo_location_interface";

// import TotalStation from "./elements/total_station.ts";
import {Instrument} from "./elements/instrument.ts";

// imports from js renderer bundle for the compatibility profile
import {Debug} from "js_renderer";
import {Canvas} from "js_renderer";
import {FlyControls} from "js_renderer";
import {WalkControls} from "js_renderer";
import {EEmbededElementTypes} from "js_renderer";
import {ProgressDispatchHelper} from "js_renderer";
import {math} from "js_renderer";
import {ESelectionType, StartActionTypeEnum} from "./modules/application/scene_application_enums";

// ensure compatibility for application modules with old namespaces
cadwork = cadwork || {};

////////////
cadwork._DEBUG = true;
/////////

cadwork.webgl = cadwork.webgl || {};
cadwork.webgl.model = cadwork.webgl.model || {};
cadwork.webgl.model.elements = cadwork.webgl.model.elements || {};
cadwork.webgl.utils = cadwork.webgl.utils || {};

cadwork.webgl.Debug = Debug;
cadwork.webgl.Canvas = Canvas;
cadwork.webgl.FlyControls = FlyControls;
cadwork.webgl.WalkControls = WalkControls;
cadwork.webgl.model.elements.EEmbededElementTypes = EEmbededElementTypes;
cadwork.webgl.utils.ProgressDispatchHelper = ProgressDispatchHelper;

// interface compatibility for applications

cadwork.webgl.SceneAPI = {};
cadwork.webgl.SceneAPI.Scene = Scene;
cadwork.webgl.SceneAPI.ViewModule = cadwork.webgl.SceneAPI.ViewModule || {};
cadwork.webgl.SceneAPI.HUD = cadwork.webgl.SceneAPI.HUD || {};
cadwork.webgl.SceneAPI.ViewModule = cadwork.webgl.SceneAPI.ViewModule || {};
cadwork.webgl.SceneAPI.elements = cadwork.webgl.SceneAPI.elements || {};
cadwork.webgl.SceneAPI.terrain = cadwork.webgl.SceneAPI.terrain || {};
cadwork.webgl.SceneAPI.terrain.Terrain = cadwork.webgl.SceneAPI.terrain.Terrain || {};
cadwork.webgl.SceneAPI.terrain.TerrainTile = cadwork.webgl.SceneAPI.terrain.TerrainTile || {};

cadwork.webgl.SceneAPI.ELogoType = ELogoType;

cadwork.webgl.SceneAPI.EBackgroundType = EBackgroundType;
cadwork.webgl.SceneAPI.EHWCameraErrors = null;
cadwork.webgl.SceneAPI.StartActionTypeEnum = StartActionTypeEnum;
cadwork.webgl.SceneAPI.ESelectionType = ESelectionType;
cadwork.webgl.SceneAPI.EOutlinesStyle = EOutlinesStyle;
cadwork.webgl.SceneAPI.BuildingElementTypeEnum = BuildingElementTypeEnum;
cadwork.webgl.SceneAPI.FaceClassificationEnum = FaceClassificationEnum;

cadwork.webgl.SceneAPI.ViewModule.MouseActionEnum = MouseActionEnum;
cadwork.webgl.SceneAPI.ViewModule.ViewModeEnum = ViewModeEnum;
cadwork.webgl.SceneAPI.ViewModule.EViewControls = EViewControls;
cadwork.webgl.SceneAPI.ViewModule.EViewControlsType = EViewControlsFamily;

cadwork.webgl.SceneAPI.elements.Curve = Curve;
cadwork.webgl.SceneAPI.elements.PoiEntity = PoiEntity;
cadwork.webgl.SceneAPI.elements.AnimationEntity = AnimationEntity;
cadwork.webgl.SceneAPI.elements.MeasurePointEntity = MeasurePointEntity;

cadwork.webgl.SceneAPI.terrain.Terrain.TEXTURE_SIZE = Terrain.TEXTURE_SIZE;
cadwork.webgl.SceneAPI.terrain.TerrainTile.TILE_SIZE = TerrainTile.TILE_SIZE;

cadwork.webgl.SceneAPI.HUD.CompassTypeEnum = CompassTypeEnum;

cadwork.webgl.SceneAPI.RenderSettingsModule = RenderSettingsModule;

cadwork.webgl.SceneAPI.EShadowType = EShadowType;
cadwork.webgl.SceneAPI.ESunDirectionType = ESunDirectionType;
cadwork.webgl.SceneAPI.ELightingDateTimeType = ELightingDateTimeType;
cadwork.webgl.SceneAPI.ELightingDateTimeType = ELightingDateTimeType;
cadwork.webgl.versionInfo = VersionInfo.versionInfo;

cadwork.math = math;

// for application which uses vec3
import * as glm from "gl-matrix";
global.vec3 = glm.vec3;
